import React from "react"
import { useTranslation } from "react-i18next"
import AnimatedValue from "../../components/AnimatedNumber"
import { useWidgetInfo } from "../../utils/useWidgetInfo"
import WidgetInfo from "../../components/WidgetInfo"
import { IconQuestion } from "../../assets/icons"

const EstimatedOfferPriceHeader = ({ valuation }) => {
  const { t } = useTranslation()
  const widgetInfoState = useWidgetInfo()

  return (
    <div>
      <div className="flex justify-between">
        <div className="mb-4 text-accumin-neutral-500">
          {t("finances.estimated-offer-price")}
        </div>
        <div className="pl-4 pb-2 cursor-pointer">
          <IconQuestion
            className="fill-accumin-primary-electric-blue h-6 w-6 p-1 bg-accumin-secondary-sky-blue rounded-full"
            onClick={() =>
              widgetInfoState.handleOpen("labels.value-terminology", "", [
                {
                  title: "finances.offer-price",
                  key: "finances.offer-price",
                },
              ])
            }
          />
        </div>
      </div>
      <div className="w-full">
        <div className="flex justify-between items-center mb-1">
          <div>
            <div className="flex gap-1">
              <AnimatedValue
                value={valuation?.global?.offer_price * 1.03 ?? "N/A"}
                withDecimals={false}
                className="text-2xl font-bold text-accumin-primary-purple"
              />
              <div className="text-2xl font-bold text-accumin-primary-purple">
                &#36;
              </div>
            </div>
            <div className="text-sm font-bold">
              {t("labels.max-offer-price")}
            </div>
          </div>
          <div>
            <div className="flex gap-1">
              <AnimatedValue
                value={valuation?.global?.offer_price * 0.97 ?? "N/A"}
                withDecimals={false}
                className="text-2xl font-bold text-accumin-secondary-magenta"
              />
              <div className="text-2xl font-bold text-accumin-secondary-magenta">
                &#36;
              </div>
            </div>
            <div className="text-sm font-bold">
              {t("labels.min-offer-price")}
            </div>
          </div>
        </div>
      </div>
      <WidgetInfo state={widgetInfoState} />
    </div>
  )
}

export default EstimatedOfferPriceHeader
